<ng-container [ngSwitch]="SendTypeSendCategory">

  <p *ngSwitchCase="SEND_CATEGORY.SMS">SMS con alta qualità di invio verso destinatari nazionali</p>
  <p *ngSwitchCase="SEND_CATEGORY.Email">Email con verifica indirizzo e tracciatura bounce</p>
  <p *ngSwitchCase="SEND_CATEGORY.PEC"> Posta Elettronica Certificata </p>
  <p *ngSwitchCase="SEND_CATEGORY.OTPLetter"> TNotice è un servizio di Raccomandata Digitale che offre ai clienti la
    possibilità di inviare documenti legalmente validi in formato digitale. </p>

</ng-container>
